import React from "react";
import ImageIcon from "../../assets/images/img-1.jpg";

const VideoSection = ({ language, englishVideo, hindiVideo }) => {
  const selectedVideo = language === 1 ? englishVideo : hindiVideo;

  return (
    <div className="mt-4">
      {/* Video Section */}
      <div className="d-flex flex-column align-items-center justify-content-center">
        {language != null ? (
          <video
            controls
            playsInline
            style={{ width: "100%", maxWidth: 900 }}
            key={language}
            onContextMenu={(e) => e.preventDefault()} // Disable right-click
            controlsList="nodownload noremoteplayback" // Remove download & remote playback
            draggable={false} // Disable drag
          >
            <source src={selectedVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <>
            <img src={ImageIcon} alt="No Img" width="300" />
            <h5 className="text-purple fw-bold lh-lg text-center mt-3">
              🌐 Select your language to start the <br /> Introducer Portal
              Walkthrough: A Complete User Guide! 🧭✨
            </h5>
          </>
        )}
      </div>
    </div>
  );
};

export default VideoSection;
